module.exports = __webpack_public_path__ + "static/media/sleepnix-logo.f227c2d4.png";